import { useEffect, useState } from 'react';
import { useFonts } from '@/context/FontProvider';
import { SelectItem } from '@/components/ui/select';
import { SelectField } from './SelectField';
import { cn } from '@/lib/utils';

type Props = {
  fontFamily?: string;
  value: string;
  className?: string;
  onChange?: (weight: string) => void;
};

const StylesFontWeightSettings = ({
  fontFamily,
  value,
  className = 'max-w-[216px]',
  onChange,
}: Props) => {
  const { fontManager } = useFonts();

  const [weights, setWeights] = useState<
    Array<{ label: string; value: string; weight: string; style: string }>
  >([]);

  useEffect(() => {
    if (fontFamily && fontManager) {
      const weights = fontManager.getAvailableWeights(fontFamily);
      // Filter out italic variants per requirement
      const nonItalicWeights = weights.filter((weight) => !/italic/i.test(weight.value));
      setWeights(nonItalicWeights);
    }
  }, [fontFamily, fontManager]);

  const handleWeightChange = (weight: string) => {
    onChange?.(weight);
  };

  return (
    <SelectField
      onValueChange={handleWeightChange}
      className={cn(className)}
      defaultValue={value}
      size="small"
      text="Weight"
      truncate={false}
    >
      {weights.length > 0 ? (
        weights.map((weight) => (
          <SelectItem key={weight.weight} value={weight.weight}>
            {weight.label}
          </SelectItem>
        ))
      ) : (
        <SelectItem value="loading" disabled>
          Loading...
        </SelectItem>
      )}
    </SelectField>
  );
};

export default StylesFontWeightSettings;
